import { useMemo } from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.less';

const ACEPRO_CHARGE_HUB = 3628; // 特殊处理套餐id AcePro2的充电关管家

/**
 * 配件的兼容机型
 */
const Index = inject(
  'area',
  'product'
)(
  observer(({ area, product }) => {
    const {
      LANG,
      country: { X_Language },
    } = area;
    const {
      productDetail: { adapter_type_names = [], id },
      curSelectCommodityId,
    } = product;
    // 需要隐藏适配机型的产品
    const hideProductAdapterTypeList = [475, 552];

    const adapter_type_list = useMemo(() => {
      let _list = [...adapter_type_names];
      if ([ACEPRO_CHARGE_HUB].includes(curSelectCommodityId)) {
        // 中国不需要品牌词
        if (X_Language === 'zh_cn') _list.push('Ace Pro', 'Ace');
        else _list.push('Insta360 Ace Pro', 'Insta360 Ace');
      }

      // 针对部分套餐需要特殊配置的机型
      const customAdapterTypeListByCid = {
        2872: [
          'X5',
          'Ace Pro 2',
          'X4',
          'GO 3S',
          'Ace Pro',
          'Ace',
          'GO 3',
          'X3',
          LANG['product.page.adapterTypeList.one_rs_4k'],
          'GO 2',
          'ONE X2',
          'ONE R',
          'ONE X',
        ],
        1511: ['X3', 'ONE X2', 'ONE X', 'GO 3', 'GO 2', LANG['product.page.adapterTypeList.one_rs_4k'], 'ONE R'],
        1343: ['X4', 'X3', 'ONE X2'],
        3667: ['X3', 'ONE X2'],
        3174: ['GO 3S', 'GO 3', 'GO 2', 'GO'],
        3175: ['GO 3S', 'GO 3', 'GO 2', 'GO', LANG['product.page.adapterTypeList.one_rs_4k']],
        // pid 618下套餐
        3785: ['X5', 'X4', 'X3'],
        3787: ['X5', 'X4'],
        // pid 292下套餐
        1207: ['X5', 'X4', 'X3', 'ONE X2'],
        3943: ['X5'],
        // pid 684下套餐
        3945: ['X5'],
        3946: ['Flow 2 Pro', 'Flow Pro', 'Flow'],
      };

      return customAdapterTypeListByCid[curSelectCommodityId] ?? _list;
    }, [X_Language, adapter_type_names, curSelectCommodityId]);

    if (!adapter_type_names[0] || hideProductAdapterTypeList.includes(id)) return null;
    return (
      <div className={styles.productAdapterType}>
        <div className={styles.wrap}>
          <p className={styles.key}>{LANG['productNew.compatibility']}</p>
          <div className={styles.tags}>
            {adapter_type_list.map((o, k) => {
              return (
                <div className={styles.val} key={k}>
                  {o}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  })
);

export default Index;
